module.exports = __webpack_public_path__ + "img/whatsapp.bf9c5b14.svg";